import { render, staticRenderFns } from "./StudioCommunityGroupThumbnail.vue?vue&type=template&id=4ebb97e5&scoped=true&"
import script from "./StudioCommunityGroupThumbnail.vue?vue&type=script&lang=ts&"
export * from "./StudioCommunityGroupThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./StudioCommunityGroupThumbnail.vue?vue&type=style&index=0&id=4ebb97e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebb97e5",
  null
  
)

export default component.exports